<template>
  <div class="containerInsured">
    <v-row>
      <v-col>
        <QuotationBackButton @back="previousStep" class="mb-6 ml-4" />
      </v-col>
      <v-spacer />
      <QuotationFloatActionButton
        class="messageInfoInsured"
        v-if="getUserIsGuest || !getIsEmployeeUser"
        :message="infoMessage"
      />
    </v-row>
    <QuotationInsuredForm
      @submit="submit"
      v-model="formInsured"
      :options-quotation="optionsQuotation"
      @cancel="cancelQuotationButton"
    />
  </div>
</template>
<script>
import QuotationInsuredForm from "../components_agro/QuotationInsuredForm";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";
import { mapState } from "vuex";

export default {
  name: "QuotationStepInsured",
  data: () => ({
    formInsured: {}
  }),
  components: {
    QuotationInsuredForm,
    QuotationBackButton,
    QuotationFloatActionButton
  },
  mixins: [QuotationMixin],
  computed: {
    ...mapState("me", ["userIsEmployee", "userIsGuest"]),
    nextQuotationStep() {
      return {
        name: "quotation step costs",
        step: 4
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step risk",
        step: 2
      };
    },
    getUserIsGuest() {
      return this.userIsGuest;
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return "Insira os dados básicos para identificarmos o segurado. Confira os campos telefone e e-mail para entrarmos em contato.";
    }
  },
  created() {
    this.formInsured = { ...this.form };
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.disableBackButton();
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    getFormForNavigation() {
      return this.formInsured;
    },
    // Lógica a ser executada antes da descarga da página pelo navegador
    handleBeforeUnload(event) {
      event.returnValue = "Deseja realmente sair?";
    },
    disableBackButton() {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", () => {
        history.pushState(null, null, document.URL);
      });
    },
    submit(form) {
      this.$emit(
        "updateStep",
        this.payloadQuotation(form, this.nextQuotationStep)
      );
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formInsured, this.previousQuotationStep)
      );
    },
    cancelQuotation() {
      this.$emit("cancel");
    }
  },
  props: {
    form: {
      type: Object
    },
    readonlyForm: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.containerInsured
  max-width: 95% !important
  margin: 0 auto !important
.messageInfoInsured
  margin-top: -10px
</style>
